import { BookingHalfDay } from '@spiaggeit/spit-datepicker'

export enum BeachType {
  BEACH = 1,
  FREE_BEACH = 2,
  POOL = 3,
  WATER_PARK = 4,
}

export enum LicenseBookingConditionsLabelStyle {
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
}

export enum LicenseBookingMode {
  MAP = 1,
  SECTORS = 2,
}

export enum LicenseBookingCartMode {
  V_2022 = 1,
  V_2024 = 2,
}

export enum BookingRefundPolicy {
  NEVER = 1,
  DAY_BEFORE,
  FIFTEEN_DAYS,
  TWO_DAYS,
  SEVEN_DAYS,
  FIVE_DAYS,
  SIX_DAYS,
  TEN_DAYS,
  FOURTEEN_DAYS,
}

export interface License {
  bookingVehiclePlateRequired: boolean
  bookingNotesFillable: boolean
  bookingCartMode: LicenseBookingCartMode
  bookingEndPeriodOffset: number | null
  bookingHalfDay: BookingHalfDay
  bookingStartPeriod: string
  bookingEndPeriod: string
  bookingTimeLimit?: string
  bookingNextYear: boolean
  bookingSeasonal: boolean
  bookingDiscountCodeDisabled: boolean
  bookingPaymentPayCardsActive: boolean
  stripePaymentAvailable: boolean
  bankPaymentAvailable: boolean
  beachPaymentAvailable: boolean
  bookingPetFormVisible: boolean
  bookingPaymentCreditcardLimit: number
  bookingPaymentIban: string
  bookingFiscalInformationMode:
    | 'receipt-only'
    | 'invoice-only'
    | 'invoice-or-receipt'
  featureFlags: {
    timeSchedulesEnabled: boolean
  }
  posthogEnabled: boolean
  bookingPolicyUrl: string
  bookingTaxCodeRequired: boolean
  bookingPolicy: string
  bookingStatus: boolean
  bookingMode: LicenseBookingMode
  bookingUserDataNotes: string
  bookingToday: boolean
  bookingUserUmbrellasLimit?: number
  bookingSelectPeriodNotes: string
  bookingMapNotes: string
  bookingServicesNotes: string
  bookingRefundPolicy?: BookingRefundPolicy
  bookingConditionsLabelStyle: LicenseBookingConditionsLabelStyle | null
  autoAfternoonReservation: boolean
  id: number
  license: string
  mapBg: string | null
  mapBg2: string | null
  name: string
  seasonalStartDate: string
  seasonalEndDate: string
  beach: {
    id: number
    lat: number
    long: number
    address: string
    region: string
    subregion: string
    city: string
    name: string
    permalink: string
    state: string
    stateModel?: {
      name?: string
    }
    type: BeachType
  }
  warehouseOnline: boolean
  widgetWhiteLabelActive: boolean
  mapBgHeight: number
  mapBgWidth: number
}

type MainTimeSlotName = 'day' | 'morning' | 'afternoon'

export interface MainTimeSlot {
  id: number
  enabledPortal: boolean
  enabledWidget: boolean
  endTime: string
  name: MainTimeSlotName
  relevance: number
  startTime: string
}
